var exports = {
  "kL": "container__zYf0fn",
  "I6": "inputWrapper__Ec5yYT",
  "KY": "countrySelector__PTaPQe",
  "nK": "countryTrigger__FjT0n6",
  "f2": "countryOptionName__9u2yTY",
  "rr": "countryOptionCallingCode__UIdZaU",
  "Tp": "phoneInput__wn9GbA",
  "Qg": "visuallyHidden__syEduD",
};

module.exports = exports;
